import { Circle, Color, Engine, Scene, ScreenElement, SpriteSheet, Timer } from 'excalibur';
import { Enemy } from '../../actors/enemies/enemy';
import { BottomBar } from '../../actors/hud/bottom_bar';
import { Hud } from '../../actors/hud/hud';
import { Tower } from '../../actors/towers/tower';
import { Turn } from '../../actors/turn';
import { Path } from '../../actors/path';
import { MapBackground } from '../../actors/map';
import { WaveGenerator } from '../../actors/wave/wave_generator';
import { derived, Resources } from '../../resources';
import { Seal } from '../../actors/towers/seal';
import { MoneySeal } from '../../actors/towers/money_seal';
import { SongPlayer } from '../../actors/song_player';
import { LoseScene } from '../lose';

/**
 * Managed scene
 */
export class LevelOne extends Scene {
  private enemies: Enemy[] = [];
  private towers: Tower[] = [];
  private positions: number[][];

  public hud: Hud;
  public waveGenerator: WaveGenerator;

  public money = 250;
  public rolling = false;

  private player: SongPlayer;

  public onInitialize(engine: Engine) {
    this.hud = new Hud(this);
    this.add(this.hud);

    this.drawPath();

    this.hud.on('initialize', () => {
      this.hud.bottomBar.on('initialize', () => {
        this.hud.bottomBar.towerButtons.setTowers([
              Seal.getSpec(),
              MoneySeal.getSpec()
          ])
      });
    });

    this.waveGenerator = new WaveGenerator(this);
    this.add(this.waveGenerator);

    this.player = new SongPlayer(Resources.gameIntro, Resources.gameLoop);
    
    this.add(this.player);
  }

  public drawPath(){
    this.positions = [
        [450, 490],
        [480, 160], 
        [870, 160],
        [890, 705],
        [280, 785],
        [290, 970],
        [1600, 970],
        [1600, 670],
        [1300, 600],
        [1300, 280]
    ];

    for (let i = 0; i < 10 ; i++) {
      this.add(
        new Turn(i, this.positions[i][0], (this.positions[i][1] - 0.5))
      );
    }
    /*
    this.add(
      new Path(100, 100, 100, 100)
    )
    */

    this.add(
      new MapBackground(this)
    )
   
  }

  public addTower(tower: Tower) {
    this.towers.push(tower);
    this.add(tower);
  }

  public addEnemy(enemy: Enemy) {
    this.enemies.push(enemy);
    this.add(enemy);

    enemy.on('kill', () => {
      this.money += 10;
    });
  }

  public damage() {
    this.player.stop();
    this.engine.removeScene(this);
    this.engine.addScene('lose', new LoseScene())
    this.engine.goToScene('lose');
  }

  public onActivate() {}

  public onDeactivate() {}

  public onDiceRolling() {
    this.rolling = true;
  }

  public onDiceRolled(results: number[]) {
    this.rolling = false;

    for (const tower of this.towers) {
      tower.shoot(results);
    }
  }
}
